module.exports = __webpack_public_path__ + "img/10_BodenParkettleger_Foto.45e62868.jpg";